import { makeStyles, Box, Typography } from '@material-ui/core'
import React from 'react'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import CustomHeading from '../CustomHeading'

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: '17px',
    fontWeight: '600',
  },
  options: {
    fontSize: '16px',
    // fontWeight: '600',
  },
  correct: {
    color: 'red',
  },
}))

export default function QuestionAnswerDialog({ questions = [], open, handleClose }) {
  const classes = useStyles()
  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <div style={{ textAlign: 'center' }}>
        <CustomHeading heading="Questions" />
      </div>
      <br />
      {questions &&
        questions.map((val, index) => {
          return (
            <>
              <Typography className={classes.heading}>{`Question ${index + 1} :  ${val.question}`}</Typography>
              <br />
              {val.options.map((val2, index) => (
                <Typography className={classes.options}>{`Option ${index + 1} :  ${val2}`}</Typography>
              ))}
              <br />

              <Typography className={classes.correct}>{`${val.correctAnswer.length > 1 ? 'Correct Answers' : 'Correct Answer'} : ${val.correctAnswer}`}</Typography>

              <br />
            </>
          )
        })}
      <Box display="flex" justifyContent="center">
        <CustomButton text="Close" handleSubmit={handleClose} />
      </Box>
    </CustomDialog>
  )
}
